import { createEntityAdapter } from '@reduxjs/toolkit'
import { IBillMoney } from '../../types'

export const billMoneysAdapter = createEntityAdapter<IBillMoney>()